/**
 * Сервис авторизации
 * */

import client from './client'
import {AuthResult} from "./Models/authResult";
import {LocalStorage} from "quasar";
import jwt_decode from "jwt-decode";
import {TokenInfo} from "./Models/TokenInfo";
import moment = require("moment");

export interface IAuthenticationService {
  login(): Promise<AuthResult>
  isAuthenticated(): boolean
  logout(): void
}

export class AuthenticationService implements IAuthenticationService {
  private authToken: string = "authentication_token"

  public async login(): Promise<AuthResult>
  {
    const { data } = await client.post<AuthResult>('/auth_client/authentication')
    return data
  }

  public isAuthenticated(): boolean{
    const role = LocalStorage.getItem('userRole')
    const token = LocalStorage.getItem(this.authToken)

    if(token !== null && token !== undefined){
      const decoded: TokenInfo = jwt_decode(token.toString());
      const expiredDate = moment(decoded.expired_at).toDate()

      if(expiredDate > new Date()){
        return true;
      }
    }

    return false;
  }

  public logout(): void {
    localStorage.removeItem(this.authToken)
  }
}
